import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  goToNextSection: `${NAMESPACE}_WIZARD_GO_TO_NEXT_SECTION`,
  goToPreviousSection: `${NAMESPACE}_WIZARD_GO_TO_PREVIOUS_SECTION`,
  openCancelModal: `${NAMESPACE}_WIZARD_OPEN_CANCEL_MODAL`,
  toggleCancelModal: `${NAMESPACE}_WIZARD_TOGGLE_CANCEL_MODAL`,
  saveForm: `${NAMESPACE}_WIZARD_SAVE_FORM`,
  saveFormSuccess: `${NAMESPACE}_WIZARD_SAVE_FORM_SUCCESS`,
  saveFormError: `${NAMESPACE}_WIZARD_SAVE_FORM_ERROR`,
  fetchInitialFormValues: `${NAMESPACE}_WIZARD_FETCH_INITIAL_FORM_VALUES`,
  fetchInitialFormValuesSuccess: `${NAMESPACE}_WIZARD_FETCH_INITIAL_FORM_VALUES_SUCCESS`,
  clearFormState: `${NAMESPACE}_WIZARD_CLEAR_FORM`
};

export const actionCreators = {
  goToNextSection: (payload) => ({ type: actions.goToNextSection, payload }),
  goToPreviousSection: (payload) => ({ type: actions.goToPreviousSection, payload }),
  openCancelModal: (payload) => ({ type: actions.openCancelModal, payload }),
  toggleCancelModal: (payload) => ({ type: actions.toggleCancelModal, payload }),
  saveForm: (payload) => ({ type: actions.saveForm, payload }),
  saveFormSuccess: (payload) => ({ type: actions.saveFormSuccess, payload }),
  saveFormError: (payload) => ({ type: actions.saveFormError, payload }),
  fetchInitialFormValues: (payload) => ({ type: actions.fetchInitialFormValues, payload }),
  fetchInitialFormValuesSuccess: (payload) => ({ type: actions.fetchInitialFormValuesSuccess, payload }),
  clearFormState: (payload) => ({ type: actions.clearFormState, payload })
};

export default {
  actions,
  actionCreators
};
